<template>
  <div class="table">
    <div>
      <h3>乘客详情</h3>
    </div>
    <!--<div class="crumbs">-->
      <!--<el-breadcrumb separator="/">-->
        <!--<el-breadcrumb-item><i class="el-icon-lx-cascades"></i><b>乘客详情</b></el-breadcrumb-item>-->
      <!--</el-breadcrumb>-->
    <!--</div>-->
    <hr/>

    <div >
      <p><strong>乘客姓名：</strong>{{realName}}</p>
      <p><strong>身份证号：</strong>{{identity}}</p>
      <div class="block">
        <el-image :src="portraitUrl" style="width: 300px;" ></el-image>
      </div>
    </div>
    <br/>

    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><i class="el-icon-lx-cascades"></i><b>常用联系人</b></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-table :data="tableData" border class="table">
      <!--<el-table-column prop="id" label="联系人Id" width="120" align="center">-->
      <!--</el-table-column>-->
      <el-table-column prop="name" label="联系人姓名" width="120" align="center">
      </el-table-column>
      <el-table-column prop="iphone" label="联系人电话" width="120" align="center">
      </el-table-column>
      <el-table-column prop="type" label="联系人类型" width="180" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type===1">紧急联系人</span>
          <span v-if="scope.row.type===2">乘车人（用于代叫车）</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="联系人状态" width="120"  align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.state===1">有效</span>
          <span v-if="scope.row.state===0">无效</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="注册时间" width="150" :formatter="dateFormat" align="center">
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="150" :formatter="dateFormat" align="center">
      </el-table-column>
    </el-table>
    <br/>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><i class="el-icon-lx-cascades"></i><b>常用地址</b></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-table :data="tableData2" border class="table">
      <!--<el-table-column prop="id" label="地址Id" width="180" align="center">-->
      <!--</el-table-column>-->
      <el-table-column prop="name" label="地址名" width="500" align="center">
      </el-table-column>
      <el-table-column prop="type" label="地址类型" width="120" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type===0">常用地址</span>
          <span v-if="scope.row.type===1">家庭地址</span>
          <span v-if="scope.row.type===2">公司地址</span>
          <span v-if="scope.row.type===3">历史地址</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="地址状态" width="120"  align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.state===1">有效</span>
          <span v-if="scope.row.state===0">无效</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="注册时间" width="150" :formatter="dateFormat" align="center">
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="150" :formatter="dateFormat" align="center">
      </el-table-column>
    </el-table>


  </div>
</template>

<script>
  export default {
    name:'passengerInfo',
    data() {
      return {
        passengerId:'',
        portraitUrl: '',
        realName:'',
        identity:'',
        tableData: [],
        tableData2: []

      }
    },
    created() {
      this.passengerId=this.$route.query.id;
      this.portraitUrl=this.$route.query.portraitUrl;
      this.realName=this.$route.query.realName;
      this.identity=this.$route.query.identity;

      this.$post('pc_contact/getContactByPid',{
        passengerId: this.passengerId
      }).then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          if (res.data.data != null) {
            this.tableData = res.data.data
          }
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch((error) => {
        console.log(error.message)
      });

      this.$post('pc_address/getAddressListByPid',{
        passengerId: this.passengerId
      }).then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          if (res.data.data != null) {
            this.tableData2 = res.data.data
          }
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch((error) => {
        console.log(error.message)
      });

    },


    methods: {

      formatter(row, column) {
        return row.address;
      },
      filterTag(value, row) {
        return row.tag === value;
      },


      //格式转换，直接复制即可
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },

      //时间格式化
      dateFormat: function (row, column) {
        var ut = row[column.property];
        var t = new Date(ut);
        return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate() + " " + t.getHours() + ":" + t.getMinutes() + ":" + t.getSeconds();
      },
      //状态格式化
      stateFormat(row, column) {
        return row.state === 1 ? "正常" : row.state === 0 ? "风险用户" : "未知";
      },

    },
  }
</script>

<style scoped>
  .form-box {
    width: 60.5rem;
  }

  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 300px;
    display: inline-block;
  }

  .del-dialog-cnt {
    font-size: 16px;
    text-align: center
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }


</style>



// WEBPACK FOOTER //
// src/views/passenger/PassengerInfo.vue